/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Core (@accedo/xdk-core) 4.2.6
* 
*******************************************************************************/
const DEFAULT_HTTP_PROTOCOL="https:",VALID_HTTP_PROTOCOLS=["https:","http:"],relativeProtocolToAbsolute=o=>{var t,l;let T=null===(t=window)||void 0===t||null===(l=t.location)||void 0===l?void 0:l.protocol;return T&&VALID_HTTP_PROTOCOLS.includes(T)||(T="https:"),`${T}${o}`};export default relativeProtocolToAbsolute;